export default "__VITE_ASSET__CyLFJWaU__"